/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface UniversalSavedSearchHitSchema {
  id: string;
  /** @maxLength 255 */
  name: string;
  project_id: string;
  /** @maxLength 255 */
  project_title: string;
  result_count?: number | null;
}
